import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { News } from 'src/app/data/models/interfaces/news';

@Component({
  selector: 'app-news-authorization-history',
  templateUrl: './news-authorization-history.component.html',
  styleUrls: ['./news-authorization-history.component.scss'],
})
export class NewsAuthorizationHistoryComponent implements OnInit {
  @Input() news: News | undefined;

  constructor() { }

  async ngOnInit() { }

  get createdAtDay(): string {
    return moment(this.news?.createdAt).locale('pt-br').format('L');
  }

  get createdAtHour(): string {
    return moment(this.news?.createdAt).locale('pt-br').format('LT');
  }

  get updatedAtDay(): string {
    return moment(this.news?.updatedAt).locale('pt-br').format('L');
  }

  get updatedAtHour(): string {
    return moment(this.news?.updatedAt).locale('pt-br').format('LT');
  }

  get scheduledDate(): string {
    return moment(this.news?.releaseDate).locale('pt-br').format('L');
  }

  get scheduledHour(): string {
    return moment(this.news?.releaseDate).locale('pt-br').format('LT');
  }
}
